import React, { useContext, useState } from 'react';
import { injectIntl } from 'react-intl';
import Footer from '@uniiverse/library/components/footer';
import Navbar from '@uniiverse/library/components/navbar';
import LocaleContext from 'context/locale-context';
import AccountNavbar from '../../components/account-navbar';
import { LOCALES, localesNavBar } from '../../../src/lib/locale';
import { OrganizationContext } from '../../components/organization-select/withOrganization';
import { withFilters, FiltersContext } from '../../components/reports/withFilters';
import { locale } from './locale.js';
import AddOnsTable from '../../components/add-ons/table';
import styles from './styles-module.css';
import './index.css';
import { ORDERS_PAGE, ADD_ONS_PAGE } from './consts';
import NewIcon from '../../assets/add-ons/new_icon.svg';
import CloseIcon from '../../assets/add-ons/close_blue.svg';

const AddOns = injectIntl(({intl, history}) => {
  const [isBannerShowing, setIsBannerShowing] = useState(true);
  const localeContext = useContext(LocaleContext);
  const { selectedMembership } = useContext(OrganizationContext);
  const { currencies } = useContext(FiltersContext);

  const renderNewBanner = () => {
    return <div className={styles.newBannerContainer}>
      <div
        className={styles.bannerClose}
        onClick={() => setIsBannerShowing(false)}
        tabIndex={0}
        role="button"
      >
        <CloseIcon />
      </div>
      <div className={styles.bannerHeader}><NewIcon />{intl.formatMessage(locale.bannerHeader)}</div>
      <div className={styles.bannerPoints}>
        <div>{intl.formatMessage(locale.bannerPoint_1)}</div>
        <div>{intl.formatMessage(locale.bannerPoint_2)}</div>
        <div>{intl.formatMessage(locale.bannerPoint_3)}</div>
      </div>
    </div>
  }

  return (
    <>
      <Navbar
        user={localeContext.user}
        locales={localesNavBar}
        switchLocale={localeContext.switchLocale}
      />
      <AccountNavbar
        currentUser={localeContext.user}
        currencies={currencies}
      />
      <section className={styles.addOns}>
        <div className={styles.addOnsTitle}>{intl.formatMessage(locale.title)}</div>
        <div className={styles.addOnsDescription}>
          {intl.formatMessage(locale.description)}
        </div>
        {isBannerShowing && renderNewBanner()}
        <div className={styles.addOnsNavigation}>
          <a href={ADD_ONS_PAGE} className={styles.active}>{intl.formatMessage(locale.title)}</a>
          <a href={ORDERS_PAGE}>{intl.formatMessage(locale.orders)}</a>
        </div>
        <AddOnsTable
          intl={intl}
          hostId={selectedMembership.owner.id}
          hasPermissionForManageAddOns={selectedMembership.manage_add_ons}
          history={history}
        />
      </section>
      <Footer
        switchLocale={localeContext.switchLocale}
        locale={localeContext.locale}
        locales={LOCALES}
      />
    </>
  );
});

export default withFilters(AddOns);
